<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-brand center>Booking Approval Logs Dashboard</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button size="sm" @click="filterClear" variant="secondary">Clear</b-button>
              <b-button :disabled="ExcelBtnName != 'Export' ? true : false" class="ml-1 mr-1"
                @click="exportExcel" size="sm" variant="outline-info">
                {{ ExcelBtnName }}
                <b-spinner v-if="ExcelBtnName != 'Export'" small label="Small Spinner"></b-spinner>
              </b-button>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>

        <b-card>
          <b-row class="mt-2">
            <b-col class="col-md-3">
              <label>Created Date Range :</label>
              <date-range-picker :opens="openLeft" :always-show-calendars="showCal" v-model="dateRange"
                :startDate="startDate" :endDate="endDate" :locale-data="locale"
                @update="SearchFilter"></date-range-picker>
            </b-col>
            <b-col class="col-md-3">
              <label>Status</label>
              <model-list-select :list="statusList" v-model="Filter.statusFilter" option-value="statusVal"
                option-text="statusText" placeholder="Select Status" @input="SearchFilter"></model-list-select>
            </b-col>
            <b-col class="col-md-3">
              <label for="branchfilter">Branch</label>
              <model-list-select :list="$store.getters['common/getAllBranchList']" id="branchfilter"
                v-model="Filter.branchFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                @input="SearchFilter" :isDisabled="
                  $sessionsStorage.get('designation') != 'Admin' &&
                  $sessionsStorage.get('nameUser') != 'Bhavneesh'
                    ? true
                    : false
                "></model-list-select>
            </b-col>
            <b-col class="col-md-3">
              <label for="commonFilter">Common Filter</label>
              <b-form-input :formatter="capitalizeAll" v-model="Filter.commonFilter" @input="SearchFilter"
                placeholder="Search Booking No, Client, Line, Agent, User..." />
            </b-col>
          </b-row>
          <b-row class="align-content-end mt-3">
            <b-col cols="10">
              <h5 class="text-muted pull-right">
                <small v-if="isLoading == false">{{ totalRows }} Entries</small>
              </h5>
            </b-col>
            <b-col cols="2" style="padding: 0px 1rem 0 5rem">
              <model-list-select :list="PaginationList" v-model="PaginationCount" option-value="pagv" option-text="pagt"
                placeholder="Select" @input="pagechangeData()"></model-list-select>
            </b-col>
          </b-row>
        </b-card>

        <!-- Main table element -->
        <div class="table-responsive tableMain">
          <b-table show-empty stacked="md" :items="logsList" responsive :fields="Columns" primary-key="cbal_id"
            :per-page="pagination.perPage" :current-page="pagination.currentPage" :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc" :sort-direction="sortDirection" class="position-relative">
            
            <template slot="cbal_id" slot-scope="row">
              <span>
                {{ row.index + 1 + (pagination.currentPage - 1) * pagination.perPage }}
              </span>
            </template>

            <template slot="BookingNo" slot-scope="row">
              <div style="font-weight: bold; color: #36304a;">
                {{ row.item.BookingNo || 'N/A' }}
              </div>
            </template>

            <template slot="booking_info" slot-scope="row">
              <div>
                <span class="text-muted">Type:</span> <b>{{ row.item.BookingType || 'N/A' }}</b><br/>
                <span class="text-muted">For:</span> <b>{{ row.item.BookingFor || 'N/A' }}</b><br/>
                <span class="text-muted">Contract:</span> <b>{{ row.item.ContractNo || 'N/A' }}</b>
              </div>
            </template>

            <template slot="client_sline_agent" slot-scope="row">
              <div>
                <span class="text-muted">Client:</span> <b>{{ row.item.ClientName || 'N/A' }}</b><br/>
                <span class="text-muted">Line:</span> <b>{{ row.item.SlineName || 'N/A' }}</b><br/>
                <span class="text-muted">Agent:</span> <b>{{ row.item.AgentName || 'N/A' }}</b>
              </div>
            </template>

            <template slot="Reason" slot-scope="row">
              <div style="max-width: 200px; white-space: normal;">
                {{ row.item.Reason || 'N/A' }}
              </div>
            </template>

            <template slot="Remark" slot-scope="row">
              <div style="max-width: 250px; white-space: normal;">
                {{ row.item.Remark || 'N/A' }}
              </div>
            </template>

            <template slot="Status" slot-scope="row">
              <b-badge v-if="row.item.Status === 'Approved'" variant="success" class="p-2">Approved</b-badge>
              <b-badge v-else-if="row.item.Status === 'Rejected'" variant="danger" class="p-2">Rejected</b-badge>
              <b-badge v-else variant="warning" class="p-2">{{ row.item.Status || 'Pending' }}</b-badge>
            </template>

            <template slot="user_logs" slot-scope="row">
              <div>
                <span class="text-muted">Created By:</span> <b>{{ row.item.CreatedBy || 'N/A' }}</b>
                <span v-slot:default v-if="row.item.CreatedAt" class="text-muted small"><br/>at {{ row.item.CreatedAt }}</span><br/>
                <span class="text-muted">Approved By:</span> <b>{{ row.item.ApprovedBy || 'N/A' }}</b>
                <span v-slot:default v-if="row.item.ApprovalDate" class="text-muted small"><br/>at {{ row.item.ApprovalDate }}</span>
              </div>
            </template>
          </b-table>
        </div>

        <h5>
          <b-row>
            <b-col md="12" class="my-1">
              <b-pagination limit="8" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalRows" @change="onPageChange($event)"></b-pagination>
            </b-col>
          </b-row>
        </h5>
      </b-card-text>
    </b-card>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
  </div>
</template>

<script>
import NodeLockPannelService from "../../services/NodeLockPannelService";
import { ModelListSelect } from "vue-search-select";
import DateRangePicker from "vue2-daterange-picker";
import CustomLoader from "../common/customLoader.vue";
import moment from "moment";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";

export default {
  name: "BookingApprovalLogs",
  components: {
    CustomLoader,
    ModelListSelect,
    DateRangePicker,
  },
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    this.$store.dispatch(
      "common/setAllBranchList",
      JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    );
    this.$store.dispatch("setCurrentRoute", this.$router.history.current.fullPath);
    this.getCurrentLastDate();
    this.getAllApprovalLogs();
  },
  data() {
    return {
      ExcelBtnName: "Export",
      isLoading: false,
      logsList: [],
      totalRows: 0,
      openLeft: "right",
      showCal: false,
      startDate: "",
      endDate: "",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan", "Feb", "Mar", "Apr", "May", "Jun",
          "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ],
        firstDay: 0,
      },
      statusList: [
        { statusVal: "", statusText: "All" },
        { statusVal: "Approved", statusText: "Approved" },
        { statusVal: "Rejected", statusText: "Rejected" },
        { statusVal: "Pending", statusText: "Pending" },
      ],
      Filter: {
        statusFilter: "",
        branchFilter: "",
        commonFilter: "",
      },
      PaginationList: [
        { pagv: "25", pagt: "25" },
        { pagv: "50", pagt: "50" },
        { pagv: "75", pagt: "75" },
        { pagv: "100", pagt: "100" },
      ],
      PaginationCount: "25",
      pagination: {
        currentPage: 1,
        perPage: 25,
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      Columns: [
        { key: "cbal_id", label: "SN.", sortable: true, sortDirection: "desc" },
        { key: "BookingNo", label: "Booking No", sortable: true },
        { key: "booking_info", label: "Booking Details", sortable: false },
        { key: "client_sline_agent", label: "Client / Line / Agent", sortable: false },
        { key: "Reason", label: "Reason for Delay", sortable: true },
        { key: "Remark", label: "Remark", sortable: true },
        { key: "Status", label: "Status", sortable: true },
        { key: "user_logs", label: "User Logs", sortable: false },
      ],
      alert: {
        content: "",
        ok: "Ok",
      },
      debounce: null,
      generateExcel: 0,
    };
  },
  methods: {
    getCurrentLastDate() {
      const today = new Date();
      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      const format = (d) => {
        const dd = String(d.getDate()).padStart(2, "0");
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const yyyy = d.getFullYear();
        return `${yyyy}/${mm}/${dd}`;
      };

      this.startDate = format(today);
      this.dateRange = {
        startDate: format(firstDay),
        endDate: format(lastDay),
      };
    },
    getAllApprovalLogs() {
      this.isLoading = true;

      let start = "";
      let end = "";
      if (this.dateRange && this.dateRange.startDate) {
        start = moment(this.dateRange.startDate).format("YYYY-MM-DD");
      }
      if (this.dateRange && this.dateRange.endDate) {
        end = moment(this.dateRange.endDate).format("YYYY-MM-DD");
      }

      const payload = {
        filter: {
          createdAtRange: {
            startDate: start,
            endDate: end,
          },
          statusFilter: this.Filter.statusFilter,
          branchFilter: this.Filter.branchFilter,
          commonFilter: this.Filter.commonFilter,
        },
        page: this.pagination.currentPage,
        pageSize: this.pagination.perPage,
        generateExcel: this.generateExcel,
      };

      const config = this.generateExcel === 1 ? { responseType: "blob" } : {};

      NodeLockPannelService.getBookingApprovalLogList(payload, config)
        .then((response) => {
          const { data, status } = response;
          if (status === 200 && data) {
            if (this.generateExcel === 1) {
              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", `Booking_Approval_Logs_${moment().format("YYYYMMDD_HHmmss")}.xlsx`);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.generateExcel = 0;
              this.ExcelBtnName = "Export";
            } else {
              this.logsList = data.data || [];
              if (data.meta) {
                this.totalRows = data.meta.totalBookings || 0;
                this.pagination.currentPage = data.meta.currentPage || 1;
                this.pagination.perPage = data.meta.pageSize || 25;
              } else {
                this.totalRows = this.logsList.length;
              }
              this.PaginationCount = this.pagination.perPage.toString();
            }
          } else {
            this.logsList = [];
            this.totalRows = 0;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching approval logs:", error);
          this.isLoading = false;
          this.generateExcel = 0;
          this.ExcelBtnName = "Export";
        });
    },
    exportExcel() {
      this.generateExcel = 1;
      this.ExcelBtnName = "Exporting...";
      this.getAllApprovalLogs();
    },
    SearchFilter() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.pagination.currentPage = 1;
        this.getAllApprovalLogs();
      }, 500);
    },
    pagechangeData() {
      this.pagination.perPage = parseInt(this.PaginationCount);
      this.pagination.currentPage = 1;
      this.getAllApprovalLogs();
    },
    onPageChange(page) {
      this.pagination.currentPage = page;
      this.getAllApprovalLogs();
    },
    filterClear() {
      this.Filter = {
        statusFilter: "",
        branchFilter: "",
        commonFilter: "",
      };
      this.getCurrentLastDate();
      this.pagination.currentPage = 1;
      this.getAllApprovalLogs();
    },
    capitalizeAll(str) {
      return str ? str.toUpperCase() : "";
    },
  },
};
</script>

<style scoped>
a:not(.md-button):not(.md-bottom-bar-item):hover {
  text-decoration: none !important;
}
.tableMain >>> td {
  vertical-align: middle !important;
}
</style>



// WEBPACK FOOTER //
// bookingApprovalLogs.vue?9fb3da7c